import {
  cellRenderParseData
} from '../../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'readyProfileSize',
    caption: 'Профилеразмер ГП',
    dataType: 'string'
  },
  {
    dataField: 'readyLength',
    caption: 'Длина ГП',
    dataType: 'number'
  },
  {
    dataField: 'zdvlOrderNumId',
    caption: 'Заказ ZDVL',
    dataType: 'integer'
  },
  {
    dataField: 'zdvlLineId',
    caption: 'Позиция ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'qcId',
    caption: 'СК',
    dataType: 'string'
  },
  {
    dataField: 'accountingDate',
    cellRender: cellRenderParseData,
    caption: 'Дата СК(рулон)',
    dataType: 'string'
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number'
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во ост.',
    dataType: 'number'
  }
];

const columnDataPart = [
  {
    dataField: 'weightEndProduct',
    caption: 'Кол-во ГП',
    dataType: 'number'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number'
  },
  {
    dataField: 'checkbox',
    caption: 'Тип чекбокса',
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'incomingDate',
    caption: 'Дата приемки',
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'pieceNumId',
    caption: 'id ПФ',
    notVisible: true,
    dataType: 'integer'
  },
  {
    dataField: 'psStatusNumId',
    caption: 'id статуса',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'thick',
    caption: 'Толщина ПФ',
    dataType: 'number'
  },
  {
    dataField: 'width',
    caption: 'Ширина ПФ',
    dataType: 'number'
  },
  {
    dataField: 'mark',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'taskNumber',
    caption: 'Номер задания',
    dataType: 'string'
  },
  {
    dataField: 'taskDate',
    dataType: 'date',
    cellRender: cellRenderParseData,
    caption: 'Дата задания'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export { columnDataGrid, columnDataPart };
